import script from "./ArticleEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleEditPage.vue?vue&type=script&setup=true&lang=js"

import "./ArticleEditPage.vue?vue&type=style&index=0&id=73a9143d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73a9143d"]])

export default __exports__